import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";


const AddSeries = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
  });

  const saveSeries = () => {
    if (formValue.name) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.SERIES_UPDATE : API_URL.SERIES_SAVE;
      axios
        .post(pUrl, formValue)
        .then((res) => {
          setLoading(false);
          if (res.data.status === 1) {
            if (id) {
              toast.success("Updated", {
                autoClose: 3000,
                
              });
              setTimeout(() => {
                navigate("/series", { replace: true });
              }, 100);
            } else {
              setTimeout(() => {
                navigate("/series", { replace: true });
              }, 100);
              toast.success("Saved", {
                autoClose: 3000,
                
              });
            }
          } else {
            toast.error(res.data.data, { autoClose: 3000 });
          }
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setError(true);
      toast.error("Please enter valid details", {
        autoClose: 3000,
        
      });
    }
  };

  const isShowError = (value) => {
    if (
      isError &&
      (!value || value == "" || value == null || value == undefined)
    ) {
      return true;
    }
    return false;
  };

  const onEdit = () => {
    axios.post(API_URL.SERIES_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
        });
      }
    });
  };

  const getInputStyles = (isError) => ({
    borderColor: isError ? "red" : undefined,
  });


  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Series</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/series"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label
                        className={`form-label ${
                          isShowError(formValue.name) && "required-field"
                        }`}
                      >
                        Name<span className="required-star">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formValue.name}
                        className="form-control"
                        placeholder="Ex. Glossy"
                        id="name"
                        style={getInputStyles(isShowError(formValue.name))}
                        onChange={(event) => {
                          setFormValue({
                            ...formValue,
                            name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={saveSeries}
                      // disabled={loading}
                      className="btn btn-primary"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSeries;
